import { useState, useEffect } from "react";
import MinutesPrint from "../../../../components/Views/MinutesPrint";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

function MinutesPrintIndex() {
  const isMounted = useMounted();
  return <div>{isMounted ? <MinutesPrint /> : <div />}</div>;
}

export default MinutesPrintIndex;
